export default {
      id: "gTranslate-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#gTranslate-usage",
      toString: function () {
        return this.url;
      }
    }